import React, { useEffect, useState } from 'react';
import api from '../../../../services/api';

export function useGetEgressoReprovados_por_projeto_no_ano() {
  const [reprovados_por_projeto_no_ano, set_data_set_turma] = useState<any>(null);

  async function handle_egresso_reprovados_por_projeto_no_ano(year?: string) {
    const { data } = await api.get(`/reports/reprovados_por_projeto_no_ano`, { params: { year } });
    set_data_set_turma(data);
  }

  useEffect(() => {
    handle_egresso_reprovados_por_projeto_no_ano();
  }, []);

  return { reprovados_por_projeto_no_ano, handle_egresso_reprovados_por_projeto_no_ano };
}
